var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupeeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.43 10L0.91 5.604V4.568H1.75C2.086 4.568 2.38 4.52133 2.632 4.428C2.89333 4.32533 3.108 4.18067 3.276 3.994C3.45333 3.80733 3.57467 3.58333 3.64 3.322H0.91V2.286H3.626C3.57 2.04333 3.472 1.82867 3.332 1.642C3.20133 1.45533 3.024 1.31067 2.8 1.208C2.58533 1.096 2.324 1.04 2.016 1.04H0.91V0.00399935H7.224V1.04H5.026C5.18467 1.21733 5.31533 1.40867 5.418 1.614C5.53 1.81933 5.60467 2.04333 5.642 2.286H7.224V3.322H5.67C5.57667 4.01267 5.31067 4.554 4.872 4.946C4.43333 5.32867 3.86867 5.59 3.178 5.73L5.922 10H3.43Z",
    fill: "#FF5956"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeeIcon);
export default __webpack_public_path__ + "static/media/rupee_icon.d5ee4afa269742540a75f69794fb3027.svg";
export { ForwardRef as ReactComponent };